import React, { ReactNode, useEffect } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import crossIcon from '@assets/icons/croosIcon.svg'

interface FormModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  width?:string
  modalTitle:string;
  height?:string;
  overflow?:string;
  
}

const FormModal: React.FC<FormModalProps> = ({modalTitle, isOpen, onClose, width,height, overflow,children  }) => {
  const { handleSubmit, formState: { isValid } } = useForm({ mode: 'onChange' });

  // Close the modal when clicking outside of it
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      const modal = document.getElementById('modal-content');
      if (modal && !modal.contains(event.target as Node)) {
        onClose();
      }
    };

    // Disable scroll when the modal is open
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.body.style.overflow = '';
      document.removeEventListener('mousedown', handleOutsideClick);
    }

    // Cleanup on component unmount
    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50  ">
      <div
        id="modal-content"
        className={`relative max-h-[95vh]  bg-white rounded-3xl shadow-lg mx-3  ${width && width} ${overflow &&  overflow }` }
      >
        <div className='sticky top-0  bg-p-gray flex justify-between py-4 px-8 rounded-t-2xl'>
          <h1 className='font-semibold text-lg'>{modalTitle}</h1>
          <button
          // className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          onClick={onClose}
        >
         {<img src={crossIcon} className='w-6'/>}
        </button>
        </div>
        <div
      className="py-4 px-8 overflow-y-auto"
      style={{ maxHeight: '90vh', borderRadius: 'inherit' }} // Use borderRadius inherit to apply the same rounded corners
    >
      {children}
    </div>
      
      </div>
    </div>
  );
};

export default FormModal;

